export default __webpack_public_path__ + "static/media/wreckingball-intro.b811ff66.mp3";